import Section from "../Section"
import './ThirdSection.scss'
import Flow from "./flow"
import FlowM from "./flow_m"

const ThirdSection = () => {
  return (
    <div id="flow">
      <Section title="Como funciona o processo de registro de marca?" >
        <div className="third-section-container" >
          <div className="third-section-flow-area-d">
            <Flow />
          </div>
          <div className="third-section-flow-area-m">
            <FlowM />
          </div>
        </div>
      </Section>
    </div>

  )
}

export default ThirdSection